const camelToDots = str => str
    .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
    .replace(/([A-Z])/g, ([letter]) => `:${letter.toLowerCase()}`)

const seo = {
    data() {
        return {
            seo: {
                title: '',
                h1: '',
                canonical: '',
                description: '',
                robots: ''
            }
        }
    },
    head: {
        title: function () {
            return {
                inner: this.seo.title
            }
        },
        meta: function () {
            const meta = []
            if (this.seo.h1 && this.seo.h1.length) {
                meta.push({n: 'h1', c: this.seo.h1, id: 'h1'})
            }
            if (this.seo.description && this.seo.description.length) {
                meta.push({n: 'description', c: this.seo.description, id: 'description'})
            }

            if (typeof this.seo.openGraphTags === 'object' && this.seo.openGraphTags !== null) {
                const tags = this.seo.openGraphTags;
                for (let i in tags) {
                    meta.push({p: camelToDots(i), c: tags[i]})
                }
            }
            if (typeof this.seo.twitterCardTags === 'object' && this.seo.twitterCardTags !== null) {
                const tags = this.seo.twitterCardTags;
                for (let i in tags) {
                    meta.push({n: camelToDots(i), c: tags[i]})
                }
            }

            if (Object.keys(this.$route.query).length) {
                meta.push({n: 'robots', c: 'noindex, nofollow'})
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            const link = []
            if (this.seo.canonical && this.seo.canonical.length) {
                link.push({r: 'canonical', h: this.seo.canonical, id: 'canonical'},)
            }

            return link
        }
    }
}

export {
    seo
}
